const SupportsFeature = ({ supports }) => (
  <>
    <span className={`supports supports-${supports ? 'yes' : 'no'}`} />
    <span className="sr-only">{supports ? 'Yes' : 'No'}</span>
  </>
);

export default SupportsFeature;
